import React from 'react';
import './section10.css';
import Title from '../common/title';
import Btn from '../common/btn';
import { useNavigate } from 'react-router-dom';


const Sec10 = () => {
    const navigate = useNavigate();
  
    const goToVR = () => {
      navigate('/vr-tour'); 
    };
    return (  
  
 <section className="sec10-contanier">
   <div className="video-wrapper">
      <video 
        width="100%" 
        height="auto" 
        controls 
        muted 
        autoPlay 
        loop
        style={{ borderRadius: '80px' }}
      >
       <source src="/video3D.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>

      <div className="sec10-content-side">

        <div className="sec10-card top-card">
          <Title title="Visual Tour of Our Villas" t="titlew" />
          <p className="sec10-subtitle">Step Inside: A Virtual Tour of Golden Hills Villas</p>
          <ul className="feature-list">
            <li>Embedded Virtual Tour:</li>
            <li>Video Tour Option:</li>
          </ul>
        </div>


        <div className="sec10-card bottom-card">
          <p className="sec10-description">
            Experience the beauty of Golden Hills Villas from the comfort of your home. 
            Our virtual tour offers an immersive look into the elegance, design, and 
            features of our villas. Walk through spacious living areas, explore lush 
            private gardens, and discover every detail that makes our villas unique.
          </p>
          <Btn btn="Open Viewer"  onClick={goToVR} />
        </div>
      </div>
    </section>
  );
}
 
export default Sec10;